import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const LinkedItem = styled.a`
  ${tw`no-underline`}
  font-size: ${rem(12)};
  color: var(--color-blue-grey);

  &:hover {
    ${tw`underline`}
    color: var(--color-gold);
  }
`

export const UnlinkedItem = styled.span``
